// Filter out non-numeric characters by keeping only digits
export const cleanPhoneNumber = (phoneNumber?: string | null) =>
  phoneNumber?.replace(/[^+\d]/g, '') ?? phoneNumber;
